import {
  Button,
  TextField,
  FormControlLabel,
  Radio,
  RadioGroup,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';

import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom';

import React, { useState, useEffect, useRef, useContext } from 'react';
import { FDContext } from 'contexts/Map/fdStore';
import { useCreditContext } from 'contexts/Credit';
import {
  setFeature,
  setMode,
  setPoint,
  setToken,
  setOrderName,
} from 'contexts/Map/action';

import debounce from 'lodash.debounce';
import { MapContext, usePopupContext, useClearMapPopups } from './index';

import { domain, apiVersion } from '../../config/config';
import Disclaimer from './Disclaimer';
import ResponseDisplay from './ResponseDisplay';
import UrlDisplay from './UrlDisplay';
import InputField from './InputField';
import CreateSubscription from './CreateSubscription';

// import { usePopupContext } from '.';

const useStyles = makeStyles({
  info: {
    padding: '12px 20px',
    boxSizing: 'border-box',
    color: '#949EA7',
    backgroundColor: '#fff',
    marginBottom: 0,
    '& h3': {
      lineHeight: '24px',
      marginBottom: 8,
      color: '#1D2023',
    },
    '& h4': {
      color: '#1D2023',
      fontSize: 18,
      lineHeight: '24px',
      fontWeight: 600,
      margin: 0,
    },
    '& h6': {
      color: '#1D2023',
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 700,
      margin: 0,
    },
  },
  iconRoot: {
    fill: 'none',
  },
  mt8: {
    marginTop: 8,
  },
  discoverButton: {
    backgroundColor: '#01B075',
    color: '#fff',
    borderRadius: 4,
    textTransform: 'capitalize',
    lineHeight: '28px',
    fontWeight: 600,
    padding: '6px 24px',
    marginTop: 24,
  },
  email: {
    color: '#01B075',
    fontSize: 16,
    fontWeight: 600,
    textDecoration: 'underline',
  },
  getInTouch: {
    color: '#1D2023',
    marginBottom: 4,
    lineHeight: '24px',
    fontSize: 16,
  },
  flex: {
    display: 'flex',
  },
  flex1: {
    flex: 1,
  },
  rightContainer: {
    flex: 1,
    wordWrap: 'anywhere',
    color: '#1D2023',
    '& h6': {
      marginBottom: 16,
    },
    marginBottom: 30,
  },
  responseContainer: {
    display: 'flex',
    marginBottom: 16,
    fontWeight: 700,
    marginTop: 16,
  },
  responseCode: {
    marginRight: 24,
    width: 58,
    lineHeight: '20px',
  },
  inputRoot: {
    borderRadius: 4,
  },
  generateResp: {
    marginTop: '16px !important',
    minHeight: '48px !important',
    borderRadius: '4px !important',
    textTransform: 'capitalize !important',
    fontWeight: '600 !important',
    fontSize: '16px !important',
  },
  textFields: {
    display: 'flex',
    marginTop: 12,
    '@media (max-width: 600px)': {
      flexWrap: 'wrap',
      '& >div': {
        marginRight: '0px !important',
        marginBottom: 8,
      },
    },
  },
  radioGroupRoot: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 8,
  },
  typeOfBiling: {
    fontSize: 15,
    marginRight: 12,
    color: '#1D2023',
    width: 156,
  },
  createButton: {
    marginTop: '16px',
  },
});

const PointDrawer = (props) => {
  const classes = useStyles();
  const { tokens, datainfo, onDataChange } = props;
  const location = useLocation();
  // console.log('location-point: ', location);
  const { map, zoomLevel, longitude, latitude } = useContext(MapContext);
  const {
    creditState: { availableCredits, isLoading: creditApiLoadingState },
  } = useCreditContext();
  // console.log('MapContext map:', map);

  // // ... existing code ...

  // // ... existing code ...
  // console.log('Zoom Level:', zoomLevel);
  // console.log('Latitude:', latitude);
  // console.log('Longitude:', longitude);
  // // ... existing code ...

  // console.log('tokens at point', tokens);

  const {
    state: { mode: mapDrawMode, point, token, orderName, dataLayerFD },
    dispatch,
  } = useContext(FDContext);

  const [coordinates, setCoordinates] = useState(datainfo?.coordinates || []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOrderClicked, setIsOrderClicked] = useState(false);

  // const [token, updateToken] = useState(
  //   initialToken || (tokens.length > 0 ? tokens[1].value : '')
  // );
  const [responseJson, setResponseJson] = useState();
  const [responseStatus, setResponseStatus] = useState();
  const [requestUrl, setRequestUrl] = useState();
  const [simplifiedGeometry, setSimplyfiedGeometry] = useState('false');
  const [version, setVersion] = useState('latest');
  const prevCoordinatesRef = useRef(coordinates);

  const clearMapboxPopup = useClearMapPopups();

  // const defaultLiveToken = tokens.find((t) => t.label === 'live')?.value || '';
  // useEffect(() => {
  //   // Set the default token when component mounts
  //   if (defaultLiveToken) {
  //     dispatch({
  //       type: setToken,
  //       payload: {
  //         token: defaultLiveToken,
  //       },
  //     });
  //   }
  // }, [defaultLiveToken, dispatch]);
  useEffect(() => {
    const lng = point && point.length && point[0];
    const lat = point && point.length && point[1];
    if (lng) {
      setCoordinates([lng, lat]);
    }
  }, [point]);

  useEffect(() => {
    const debouncedSave = debounce(() => {
      dispatch({
        type: setPoint,
        payload: {
          point: coordinates,
        },
      });
    }, 100);

    if (point && point.length) {
      if (point[0] !== coordinates[0] || point[1] !== coordinates[1]) {
        debouncedSave();
      }
    }
  }, [coordinates]);

  const formData = {
    orderName,
    coordinates,
    token,
    version,
    simplifiedGeometry,
    requestUrl,
    dataLayerFdType: 'delineated_fields',
    zoomLevel,
    latitude,
    longitude,
  };
  // console.log(formData);

  useEffect(() => {
    if (
      onDataChange &&
      (prevCoordinatesRef.current[0] !== coordinates[0] ||
        prevCoordinatesRef.current[1] !== coordinates[1])
    ) {
      const additionalData = {
        version,
        simplifiedGeometry,
        token,
        requestUrl:
          `${domain}/${apiVersion}/delineated-fields/location` +
          `?token=${token}` +
          `&location=${coordinates.join(',')}` +
          `&data_version=${version}` +
          `&simplified_geometry=${simplifiedGeometry}`,
        tag: responseJson ? 'success' : 'failure',
      };
      onDataChange({ coordinates, ...additionalData });
      prevCoordinatesRef.current = coordinates;
    }
  }, [
    coordinates,
    onDataChange,
    version,
    simplifiedGeometry,
    token,
    responseJson,
  ]);

  const handleOrderNameChange = (event) => {
    dispatch({
      type: setOrderName,
      payload: { orderName: event.target.value },
    });
  };

  const handleClick = () => {
    if (availableCredits <= 2 && !creditApiLoadingState) {
      return;
    }
    const fetchUrl =
      `${domain}/${apiVersion}/delineated-fields/location` +
      `?token=${token}` +
      `&location=${coordinates.join(',')}` +
      `&data_version=${version}` +
      `&simplified_geometry=${simplifiedGeometry}`;

    // Ensure we clear any existing popups when generating a response
    clearMapboxPopup();

    setRequestUrl(fetchUrl);

    fetch(fetchUrl)
      .then((response) => {
        setResponseStatus(response.status);
        return response.json();
      })
      .then((data) => {
        setResponseJson(data);
      })
      .catch((error) => {
        setResponseStatus('Error');
        setResponseJson(null);
      });
  };

  useEffect(() => {
    if (responseJson && typeof responseJson === 'object') {
      dispatch({
        type: setFeature,
        payload: {
          feature: responseJson,
        },
      });

      // console.log('Debugging Modal', responseJson);

      setIsModalOpen(true);
    }
  }, [responseJson]);

  const isGenerateResponseDisabled =
    !orderName ||
    !coordinates.length ||
    !token ||
    !version ||
    (availableCredits <= 2 && !creditApiLoadingState);

  return (
    <div className={classes.root}>
      <div className={classes.info}>
        <h4 style={{ display: 'none' }}>/delineated-fields/location</h4>
        <p style={{ marginBottom: '24px' }}>
          Returns the field for the given location.
        </p>

        <div className={classes.radioGroupRoot}>
          <div className={classes.typeOfBiling}>Simplified Geometry :</div>
          <RadioGroup
            row
            aria-label="simplified geometry"
            name="simplified_geometry"
            value={simplifiedGeometry}
            onChange={(e) => {
              setSimplyfiedGeometry(e.target.value);
            }}
            disabled={isOrderClicked} // Disable when order is clicked
          >
            <FormControlLabel
              value="false"
              control={<Radio color="primary" />}
              label="False"
              labelPlacement="end"
            />
            <FormControlLabel
              value="true"
              control={<Radio color="primary" />}
              label="True"
              labelPlacement="end"
            />
          </RadioGroup>
        </div>
        <div className={classes.textFields}>
          <InputField
            label="Location in format of longitude"
            value={(coordinates && coordinates[0]) || ''}
            className="mr-12"
            onChange={(e) => {
              setCoordinates([e.target.value, coordinates[1]]);
            }}
            disabled={isOrderClicked} // Disable when order is clicked
          />
          <InputField
            label="Location in format of latitude"
            value={(coordinates && coordinates[1]) || ''}
            onChange={(e) => {
              setCoordinates([coordinates[0], e.target.value]);
            }}
            disabled={isOrderClicked} // Disable when order is clicked
          />
        </div>
        <div className={classes.textFields}>
          <InputField
            label="Data Version"
            value={version}
            className="mr-12"
            onChange={(e) => {
              setVersion(e.target.value);
            }}
            disabled={isOrderClicked} // Disable when order is clicked
          />
        </div>
        {availableCredits <= 2 && !creditApiLoadingState && (
          <div
            style={{
              color: '#d32f2f',
              fontSize: '14px',
              marginTop: '16px',
              padding: '8px',
              backgroundColor: '#ffebee',
              borderRadius: '4px',
            }}
          >
            Insufficient credits available. Please add credits to generate
            response.
          </div>
        )}

        {!isOrderClicked && (
          <Button
            variant={
              coordinates && coordinates.length ? 'contained' : 'outlined'
            }
            color="primary"
            onClick={handleClick}
            fullWidth
            className={classes.generateResp}
            disabled={isGenerateResponseDisabled}
          >
            Generate Response
          </Button>
        )}

        <CreateSubscription
          name={orderName}
          formData={formData}
          apiType="location"
          result={{
            responseJson,
            responseStatus,
            zoomLevel,
            latitude,
            longitude,
          }}
          onClose={() => {
            setIsOrderClicked(true);
            setIsModalOpen(false);
          }}
          isModalOpenSub={isModalOpen}
          setIsModalOpenSub={setIsModalOpen}
          setIsOrderClicked={setIsOrderClicked}
          modalTitle="Query by Point"
          modalDescription="Create order for /delineated-fields/location endpoint"
          disabled={availableCredits <= 2 || creditApiLoadingState}
        />

        {/* <Disclaimer /> */}
      </div>

      {responseStatus && (
        <div className={classes.info}>
          <h3>Response Body</h3>
          {/* <UrlDisplay requestUrl={requestUrl} /> */}
          <div className={classes.responseContainer}>
            <div className={classes.responseCode}>{responseStatus}</div>
            <div className={classes.rightContainer}>
              <h6>
                {responseStatus === 200 && 'Successfully fetched'}{' '}
                {responseStatus === 404 && 'Field not found at the location'}
              </h6>
              <ResponseDisplay
                responseJson={responseJson}
                responseStatus={responseStatus}
              />
              {!responseJson && (
                <div className={classes.responseContainer}>
                  Please check the coverage API to see if we have data for the
                  region you are querying. The test token allows you to query to
                  the DR API for only a sample area of each region. If you wish
                  to query outside the sample region shown get in touch with us
                  at hello@digifarm.io
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PointDrawer;
